/** App chrome: navigation, actions, status. Not used for entities. */
import { c, dot, rr, type Glyph } from './geom.js';

export const UI: Record<string, Glyph> = {
  chevron: 'm9 5 7 7-7 7',
  'chevron-down': 'm5 9 7 7 7-7',
  'chevron-up': 'm5 15 7-7 7 7',
  back: 'm14 5-7 7 7 7',
  check: 'm5 13 4 4L19 7',
  close: 'M6 6l12 12M18 6 6 18',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  more: `${c(5, 12, 1.2)}${c(12, 12, 1.2)}${c(19, 12, 1.2)}`,
  menu: 'M4 7h16M4 12h16M4 17h16',
  share: 'M12 15V4M8.5 7.5 12 4l3.5 3.5M5 13v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6',
  download: 'M12 4v10M8.5 10.5 12 14l3.5-3.5M5 17v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v4h-4',
  expand: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5',
  plane: 'M12 2.5c.9 0 1.5 1 1.5 2.3V9l7.5 4.5v2L13.5 13v4.6l2.5 1.9V21L12 19.8 8 21v-1.5l2.5-1.9V13L3 15.5v-2L10.5 9V4.8c0-1.3.6-2.3 1.5-2.3z',
  link: 'M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1-1',
  cake: 'M4 21h16M5 21v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7M5 16c1.2 1 2.5 1 3.5 0s2.3-1 3.5 0 2.3 1 3.5 0 2.3-1 3.5 0M12 12V9M12 6.5c-.9-.6-1-1.9 0-3 1 1.1.9 2.4 0 3z',
  pencil: 'M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3zM14 8l3 3',
  trash: 'M4 7h16M10 4h4M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12M10 11v6M14 11v6',
  video: `${rr(3, 6, 13, 12, 2)}M16 10.5 21 7.5v9l-5-3`,
  external: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  grid: `${rr(3, 3, 7, 7, 1.5)}${rr(14, 3, 7, 7, 1.5)}${rr(3, 14, 7, 7, 1.5)}${rr(14, 14, 7, 7, 1.5)}`,
  rooms: `${rr(3, 3, 8, 8, 2)}${rr(13, 3, 8, 8, 2)}${rr(3, 13, 8, 8, 2)}${rr(13, 13, 8, 8, 2)}`,
  list: `M8 6h12M8 12h12M8 18h12${dot(4, 6)}${dot(4, 12)}${dot(4, 18)}`,
  hash: 'M5 9h15M4 15h15M10 3 8 21M16 3l-2 18',
  text: 'M4 6h16M4 12h10M4 18h13',
  inbox: 'M3 13h5l1.5 3h5L16 13h5M5.5 5h13L21 13v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6z',
  chart: 'M4 4v16h16m-13-5 4-4 3 3 5-6',
  settings:
    `${c(12, 12, 3)}M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z`,
  sliders: 'M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1M15 4v4M9 10v4M17 16v4',
  user: `${c(12, 8, 4)}M4 21a8 8 0 0 1 16 0`,
  users: `${c(9, 8, 3.5)}M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6.5 6.5 0 0 1 3.5 6`,
  logout: 'M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 8l-4 4 4 4M6 12h10',
  alert: `M10.3 4 2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4a2 2 0 0 0-3.4 0zM12 9v4.5${dot(12, 17)}`,
  info: `${c(12, 12, 9)}M12 11v5${dot(12, 8)}`,
  question: `${c(12, 12, 9)}M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7${dot(12, 17)}`,
  eye: `M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z${c(12, 12, 3)}`,
  hold: 'M9 11V5a1.5 1.5 0 0 1 3 0v5M12 10V4a1.5 1.5 0 0 1 3 0v6M15 10V6a1.5 1.5 0 0 1 3 0v7a7 7 0 0 1-7 7h-.5a6 6 0 0 1-4.6-2.2L3.5 14.5a1.6 1.6 0 0 1 2.3-2.2L9 15',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
  // media transport
  play: 'M8 5.5v13l11-6.5z',
  pause: 'M9.5 5v14M14.5 5v14',
  stop: rr(6, 6, 12, 12, 2),
  prev: 'M17 5.5v13L7 12zM5 5v14',
  next: 'M7 5.5v13L17 12zM19 5v14',
  volume: 'M4 9h4l5-4v14l-5-4H4zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12',
  mute: 'M4 9h4l5-4v14l-5-4H4zM17 9.5l5 5M22 9.5l-5 5',
  shuffle: 'M3 7h3.5c2 0 3.2.9 4.3 2.6l2.4 4.8c1.1 1.7 2.3 2.6 4.3 2.6H21M18 14l3 3-3 3M3 17h3.5c1.4 0 2.4-.4 3.2-1.2M14.3 8.2c.8-.8 1.8-1.2 3.2-1.2H21M18 4l3 3-3 3',
  repeat: 'M4 11V9a3 3 0 0 1 3-3h13M17 3l3 3-3 3M20 13v2a3 3 0 0 1-3 3H4M7 21l-3-3 3-3',
  'repeat-one': 'M4 11V9a3 3 0 0 1 3-3h13M17 3l3 3-3 3M20 13v2a3 3 0 0 1-3 3H4M7 21l-3-3 3-3M11.5 10.5l1.5-1v5',
  queue: `M4 6h12M4 11h12M4 16h7${c(17.5, 17.5, 2)}M19.5 17.5V10l2 .8`,
  search: `${c(10.5, 10.5, 6.5)}M15.5 15.5 20 20`,
  'speaker-group': `${rr(3, 5, 8, 14, 2)}${c(7, 14, 2)}${rr(13, 5, 8, 14, 2)}${c(17, 14, 2)}`,
};
